import React from 'react';
import styled from 'styled-components';
import { isiOS } from '../themes';

export const ContentBlockBase = styled.div.attrs({
  className: 'content-block'
})`
  ${isiOS() ?
    `
      margin-left: 15px;
      padding: 12px 15px 12px 0;
    ` : `
      padding: 16px;
    `
  }
`;

const ContentBlockContext = React.createContext(false);

export default ({ children, collapse, ...props }) => (
  <ContentBlockContext.Consumer>
    {
      (isNested) => isNested || collapse ? children : (
        <ContentBlockContext.Provider value={true}>
          <ContentBlockBase {...props}>{children}</ContentBlockBase>
        </ContentBlockContext.Provider>
      )
    }
  </ContentBlockContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/components/content-block.js